import type { TravelKind } from './travelOptionsModel';

const KIND_ORDER: TravelKind[] = ['flight', 'train', 'hotel'];

const KIND_LABELS: Record<TravelKind, string> = {
  flight: 'flights',
  train: 'trains',
  hotel: 'hotels',
};

function joinKinds(kinds: string[]): string {
  if (kinds.length === 1) return kinds[0];
  if (kinds.length === 2) return `${kinds[0]} and ${kinds[1]}`;
  return `${kinds.slice(0, -1).join(', ')} and ${kinds[kinds.length - 1]}`;
}

export function travelPageTitle({
  artifactTitle,
  tripName,
  kinds,
  listCount,
}: {
  artifactTitle: string;
  tripName?: string | null;
  kinds: TravelKind[];
  listCount: number;
}): string {
  if (listCount < 2 || kinds.length === 0) return artifactTitle;

  const labels = KIND_ORDER.filter((kind) => kinds.includes(kind)).map(
    (kind) => KIND_LABELS[kind],
  );
  if (labels.length === 0) return artifactTitle;

  const list = joinKinds(labels);
  if (tripName?.trim()) return `${tripName}: ${list}`;
  return `${list[0].toUpperCase()}${list.slice(1)}`;
}
